import * as React from 'react';

// Maps a Contentful ContentfulWidgetBlock `widgetType` to the element that
// renders it. Configurator widgets are site-specific (the German site's use
// `graphql`/`useStaticQuery`), so the renderers are injected per-site rather
// than imported directly by RichTextRender — that keeps RichTextRender
// graphql-free and shareable via @sorpetaler/ui.
export type WidgetBlockRenderers = Record<string, React.ReactNode>;

const WidgetBlockContext = React.createContext<WidgetBlockRenderers>({});

export const WidgetBlockProvider = ({
  renderers,
  children,
}: {
  renderers: WidgetBlockRenderers;
  children: React.ReactNode;
}): React.ReactElement => (
  <WidgetBlockContext.Provider value={renderers}>
    {children}
  </WidgetBlockContext.Provider>
);

export const useWidgetBlockRenderers = (): WidgetBlockRenderers =>
  React.useContext(WidgetBlockContext);
